import { devicesFor, parseScaleFrame, readSerialScale } from '@iws/pos-devices'

import { useEffect, useState } from 'react'

import { deviceModels, readSetup } from './setup'

/** The scale reading in the product's unit, or null when the unit is not a weight (pieces, litres…). */
const inUnit = (kg: number, unit: string) => {
  const u = unit.trim().toLowerCase()
  if (u === 'kg' || u.startsWith('kilo')) return kg
  if (u === 'g' || u.startsWith('gram')) return kg * 1000
  if (u === 'lb' || u.startsWith('pound')) return kg / 0.45359237
  return null
}

/**
 * Live weight from this till's `scale_read` scale (POS.md §18.9) while `active`, in `unit`. Null without a scale, for
 * a non-weight unit, or before the first reading. The port is closed when inactive.
 */
export const useScaleWeight = (active: boolean, unit: string) => {
  const [reading, setReading] = useState<{ value: number; stable: boolean } | null>(null)

  useEffect(() => {
    setReading(null)
    if (!active || inUnit(1, unit) === null) return
    const scale = devicesFor(readSetup(), 'scale_read', deviceModels()).find((d) => d.model.scale?.frame && d.device.handle?.serial)
    if (!scale) return
    const frame = scale.model.scale!.frame!
    let stop: (() => Promise<void> | void) | undefined
    let cancelled = false
    readSerialScale(scale.device.handle!.serial!, frame, (text) => {
      const r = parseScaleFrame(text, frame)
      const value = r ? inUnit(r.kg, unit) : null
      if (r && value !== null) setReading({ value: Math.round(value * 1000) / 1000, stable: r.stable })
    })
      .then((s) => {
        if (cancelled) void s()
        else stop = s
      })
      .catch((error) => console.warn('[pos] scale', error))
    return () => {
      cancelled = true
      void stop?.()
    }
  }, [active, unit])

  return reading
}
